import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';

/**
 * Uniform layout wrapper for a single filter field inside a `FiltersCard`.
 *
 * Produces the "Programmations" style: a responsive column with the label in
 * an `InputGroup` prepend addon, the actual input stretching next to it on
 * the same line.
 *
 * Responsive defaults: xs=12 (one field per row on mobile), md=6 (two per
 * row), lg=4 (three per row). Override any breakpoint via props.
 *
 * `wrap={false}` skips the InputGroup wrapping; use it for components that
 * already render their own prepend (e.g. `DateTimePicker` with `prependLabel`).
 */
function FilterField({
    label,
    children,
    wrap,
    xs, sm, md, lg, xl,
    className,
    colClassName,
}) {
    const col_props = { xs, sm, md, lg, xl };
    // Strip undefined breakpoints so reactstrap falls back to its own defaults.
    Object.keys(col_props).forEach((k) => {
        if (col_props[k] == null) delete col_props[k];
    });

    const body = (label && wrap !== false) ? (
        <InputGroup>
            <InputGroupAddon addonType="prepend">
                <InputGroupText className="text-nowrap">{label}</InputGroupText>
            </InputGroupAddon>
            {children}
        </InputGroup>
    ) : children;

    return (
        <Col {...col_props} className={colClassName || undefined}>
            <FormGroup className={`FiltersCard__field ${className || ''}`.trim()}>
                {body}
            </FormGroup>
        </Col>
    );
}

FilterField.propTypes = {
    label: PropTypes.node,
    children: PropTypes.node.isRequired,
    wrap: PropTypes.bool,
    xs: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sm: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    md: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lg: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    xl: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    className: PropTypes.string,
    colClassName: PropTypes.string,
};

FilterField.defaultProps = {
    label: null,
    wrap: true,
    xs: 12,
    md: 6,
    lg: 4,
    sm: undefined,
    xl: undefined,
    className: '',
    colClassName: '',
};

export default FilterField;
